module.exports = __webpack_public_path__ + "static/media/logo.18a049e5.svg";